export default Object.freeze({
    RUNTIME_ENVIRONMENT: process.env.VUE_APP_RUNTIME_ENVIRONMENT,
    NEWTIN_DOMAIN: process.env.VUE_APP_NEWTIN_DOMAIN,
    NEWTIN_GEOCODER: '/NewtinWeb/OUPS_Geocoder_NJS.njs',
});
